import React from 'react';
import Menu from '../menu/Menu'; // Import existing Menu component
import Tile from '../common/Tile'; // Import Tile component
import { useNavigate, useLocation } from 'react-router-dom';
import '../common/rtCommon.css';
import '../common/Tile.css';

const BedAllocationManagement = () => {
    const tiles = [
        {
            title: 'Allocate Bed',
            url: 'allocate-bed',
            icon: '🛏️', // Bed emoji
            description: 'Assign a bed to a paying guest.',
        },
        {
            title: 'Move Bed',
            url: 'move-bed',
            icon: '🔄', // Circular arrows emoji
            description: 'Transfer a paying guest to another bed.',
        },
        {
            title: 'View Vacant Beds',
            url: 'view-vacant-beds',
            icon: '🏠', // House emoji
            description: 'Check all beds that are currently vacant.',
        },
{
            title: 'View Allocated Beds',
            url: 'view-allocated-beds',
            icon: '👤', // Person emoji
            description: 'See all beds currently allocated to paying guests.',
        },
        {
            title: 'View Soon Vacating Beds',
            url: 'view-soon-vacating-beds',
            icon: '⏰', // Clock emoji
            description: 'See beds that will be vacated in the next 30 days.',
        },
        {
            title: 'View Allocation History',
            url: 'view-allocation-history',
            icon: '📋', // Clipboard emoji
            description: 'View beds that were allocated in the past.',
        },
        {
            title: 'Bed Pricing',
            url: 'bed-pricing',
            icon: '💰', // Money bag emoji
            description: 'View pricing details for different bed types and sharing options.',
        }
    ];
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="rt-layout">
            <Menu className="rt-menu" activePath={location.pathname} />
            <div className="rt-main-content">
                <div className="rt-title-row">
                    <h2 className="rt-title">Bed Allocation</h2>
                </div>
                <div className="rt-main-section">
                    <div className="rt-tiles-grid">
                        {tiles.map((tile, idx) => (
                            <Tile
                                key={idx}
                                icon={tile.icon} // Pass the icon to the Tile component
                                title={tile.title}
                                description={tile.description} // Pass the description to the Tile component
                                access_roles={['RT_Admin']}
                                onClick={() => tile.url && navigate(tile.url)}
                                tabIndex={0}
                                role="button"
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' && tile.url) navigate(tile.url);
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BedAllocationManagement;